module.exports = function(ads) {
  "use strict";
	ads
    .controller('adsTxtController', adsTxtController)

	adsTxtController.$inject = ["$http","getDataService", "refreshtokenService","alertService","serverError", "API_URL","offlineError"];
	
  function adsTxtController($http,getDataService,refreshtokenService, alertService,serverError, API_URL, offlineError) {
    var vmat = this;
    vmat.saveChanges = function() {
      
      var putFunction = function() {
        $http.put(API_URL + 'options/authorized-digital-sellers' , {'txt':vmat.adsTxt})
        .success(function (data, status, headers) {
            alertService('success','Success ', data.message, 2000);
        })
        .error(function (data, status, header, config) {
          if(!window.navigator.onLine) {
            offlineError()
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  putFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          }else if(status ==502) {
            serverError();
          } else {  
            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
          }
        });
      }
      putFunction();
    }
    var getFunction = function() { 
      getDataService.get({
        param1: 'options',
        param2: 'authorized-digital-sellers'   
      }).$promise.then(function(data){
        vmat.adsTxt = data.txt
      },function(error){
        if(!window.navigator.onLine) {
          offlineError('refresh')
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {   
                getFunction();
              }
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
          });
        }else if(error.status ==502) {
          serverError()
        }else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }  
      });
    }
    getFunction();
  } 
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/adsModule/adsTxt/js/adsTxtController.js
// module id = 477
// module chunks = 0